import { getBatteryColors, parseBatteryPct } from "../../utils/battery";

export function Battery({ pct }) {
  const n = parseBatteryPct(pct);
  const { bar, border } = getBatteryColors(n);
  return (
    <span
      className="sb-battery"
      aria-hidden="true"
      style={{ borderColor: border }}
    >
      <span className="sb-battery-inner">
        <span
          className="sb-battery-bar"
          style={{ width: `${n}%`, background: bar }}
        />
      </span>
      <span className="sb-battery-tip" style={{ background: border }} />
    </span>
  );
}
